import { render, staticRenderFns } from "./HubError.vue?vue&type=template&id=4da6c070"
import script from "./HubError.vue?vue&type=script&lang=js"
export * from "./HubError.vue?vue&type=script&lang=js"
import style0 from "./HubError.vue?vue&type=style&index=0&id=4da6c070&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports